import { render, staticRenderFns } from "./SimpleSearch.vue?vue&type=template&id=107ae4d0&scoped=true&"
import script from "./SimpleSearch.vue?vue&type=script&lang=js&"
export * from "./SimpleSearch.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSearch.vue?vue&type=style&index=0&id=107ae4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ae4d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107ae4d0')) {
      api.createRecord('107ae4d0', component.options)
    } else {
      api.reload('107ae4d0', component.options)
    }
    module.hot.accept("./SimpleSearch.vue?vue&type=template&id=107ae4d0&scoped=true&", function () {
      api.rerender('107ae4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/SimpleSearch.vue"
export default component.exports